import { Content } from "antd/lib/layout/layout";
import { Typography, List, Row, Col } from "antd";
import { Link } from "react-router-dom";
import MainHeading from "../mainHeading";
import Localize from "../../utils/string";

interface Props {
  ourServices: any;
}

const OurServices = (props: Props) => {
  const { ourServices } = props;
  const handleClick = () => {};
  return (
    <Content className="our-services">
      <div className="container">
        <MainHeading text={Localize.OurServicesText} onclick={handleClick()} />
        <List
          className="our-services-listing"
          dataSource={ourServices}
          renderItem={(item: any) => (
            <List.Item data-aos="fade-right">
              <Row>
                <Col className="our-services-left" xs={6} span={8}>
                  {item.id}
                </Col>
                <Col className="our-services-right" xs={18} span={16}>
                  <span className="our-services-left">{item.id}</span>
                  <div className="top">
                    {/* <item.image /> */}
                    <Typography.Title level={4}>{item.title}</Typography.Title>
                  </div>
                  <Typography.Text>{item.desc}</Typography.Text>
                  <div className="bottom">
                    {item?.id !== 3 && <Link
                      to={{
                        pathname: `/services`,
                        hash: `#${item?.key}`,
                      }}
                    >
                      {item?.button}
                     <svg xmlns="http://www.w3.org/2000/svg" width="25.625" height="17.623" viewBox="0 0 25.625 17.623"><g id="Group_280" data-name="Group 280" transform="translate(6855.444 -343.358) rotate(180)"><path id="Path_13" data-name="Path 13" d="M6838.983-343.712l-8.458-8.458,8.458-8.458" transform="translate(0.001 0)" fill="none" stroke="#fff" stroke-width="1"></path><line id="Line_7" data-name="Line 7" x2="24.5" transform="translate(6830.944 -352.426)" fill="none" stroke="#fff" stroke-width="1"></line></g></svg>
                    </Link>}
                    {item?.id === 3 && (
                      <Link
                        className="rounded-btn our-services-btn discover-services-btn"
                        to="/services"
                      >
                        {Localize.ServicesButtonText}
                        <svg xmlns="http://www.w3.org/2000/svg" width="25.625" height="17.623" viewBox="0 0 25.625 17.623"><g id="Group_280" data-name="Group 280" transform="translate(6855.444 -343.358) rotate(180)"><path id="Path_13" data-name="Path 13" d="M6838.983-343.712l-8.458-8.458,8.458-8.458" transform="translate(0.001 0)" fill="none" stroke="#fff" stroke-width="1"></path><line id="Line_7" data-name="Line 7" x2="24.5" transform="translate(6830.944 -352.426)" fill="none" stroke="#fff" stroke-width="1"></line></g></svg>
                      </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </List.Item>
          )}
        />
      </div>
    </Content>
  );
};

export default OurServices;
